import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  LEAD_NOTES_REFRESH: createSagaAction('LEAD_NOTES_REFRESH'),

  LEAD_NOTE_CREATE: createSagaAction('LEAD_NOTE_CREATE'),
  LEAD_NOTE_UPDATE: createSagaAction('LEAD_NOTE_UPDATE'),
  LEAD_NOTE_DELETE: createSagaAction('LEAD_NOTE_DELETE')
}

// Action Creators
export const actions = {
  leadNotesRefresh: ({ leadId }) => ({
    type: constants.LEAD_NOTES_REFRESH.ACTION,
    leadId
  }),

  createNote: ({ leadId, content, userId }) => ({
    type: constants.LEAD_NOTE_CREATE.ACTION,
    leadId,
    content,
    userId
  }),

  updateNote: ({ leadId, noteId, content }) => ({
    type: constants.LEAD_NOTE_UPDATE.ACTION,
    leadId,
    noteId,
    content
  }),

  deleteNote: ({ noteId, leadId }) => ({
    type: constants.LEAD_NOTE_DELETE.ACTION,
    leadId,
    noteId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.LEAD_NOTES_REFRESH.SUCCESS:
      return {
        ...state,
        leadNotes: action.payload
      }
    case constants.LEAD_NOTE_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_NOTE_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_NOTE_DELETE.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/leadFunctions/leadNoteActions.js